import React from 'react';
import { Folder, Home, MessageSquare, Settings, User } from 'react-feather';
import { Link } from 'react-router-dom';

export default function ListGroup() {
    return (
        <>
            <div className='container-fluid'>
                <div className='col-12'>
                    <nav aria-label='breadcrumb'>
                        <h2 className='mb-3'>فهرست گروهی</h2>

                        <ol className='breadcrumb'>
                            <li className='breadcrumb-item'>
                                <Link to='/'>کامپوننت ها</Link>
                            </li>

                            <li className='breadcrumb-item'>
                                <Link to='/listgroup'>فهرست گروهی</Link>
                            </li>

                            <li
                                className='breadcrumb-item active'
                                aria-current='page'
                            >
                                شما اینجایی
                            </li>
                        </ol>
                    </nav>
                </div>

                <div className='space-20' />

                <div className='row'>
                    <div className='col-sm-12 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                فهرست گروهی معمولی، فعال و لینک دار شده
                            </div>

                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-sm-12 col-md-6 col-lg-4 mb-4'>
                                        <ul className='list-group'>
                                            <li className='list-group-item'>
                                                <Folder
                                                    className='mr-2'
                                                    size={17}
                                                />
                                                آیتم اول
                                            </li>
                                            <li className='list-group-item'>
                                                <Folder
                                                    className='mr-2'
                                                    size={17}
                                                />
                                                آیتم دوم
                                            </li>
                                            <li className='list-group-item'>
                                                <Folder
                                                    className='mr-2'
                                                    size={17}
                                                />
                                                آیتم سوم
                                            </li>
                                            <li className='list-group-item'>
                                                <Folder
                                                    className='mr-2'
                                                    size={17}
                                                />
                                                آیتم چهارم
                                            </li>
                                            <li className='list-group-item'>
                                                <Folder
                                                    className='mr-2'
                                                    size={17}
                                                />
                                                آیتم پنجم
                                            </li>
                                        </ul>
                                    </div>

                                    <div className='col-sm-12 col-md-6 col-lg-4 mb-4'>
                                        <ul className='list-group'>
                                            <li
                                                className='list-group-item active'
                                                aria-current='true'
                                            >
                                                <Folder
                                                    className='mr-2'
                                                    size={17}
                                                />
                                                آیتم فعال
                                            </li>
                                            <li className='list-group-item'>
                                                <Folder
                                                    className='mr-2'
                                                    size={17}
                                                />
                                                آیتم دوم
                                            </li>
                                            <li className='list-group-item'>
                                                <Folder
                                                    className='mr-2'
                                                    size={17}
                                                />
                                                آیتم سوم
                                            </li>
                                            <li className='list-group-item'>
                                                <Folder
                                                    className='mr-2'
                                                    size={17}
                                                />
                                                آیتم چهارم
                                            </li>
                                            <li className='list-group-item'>
                                                <Folder
                                                    className='mr-2'
                                                    size={17}
                                                />
                                                آیتم پنجم
                                            </li>
                                        </ul>
                                    </div>

                                    <div className='col-sm-12 col-md-6 col-lg-4 mb-4'>
                                        <div className='list-group'>
                                            <Link
                                                to='#'
                                                className='list-group-item list-group-item-action active'
                                                aria-current='true'
                                            >
                                                آیتم لینکی فعال
                                            </Link>

                                            <Link
                                                to='#'
                                                className='list-group-item list-group-item-action'
                                            >
                                                آیتم دوم
                                            </Link>

                                            <Link
                                                to='#'
                                                className='list-group-item list-group-item-action'
                                            >
                                                آیتم سوم
                                            </Link>

                                            <Link
                                                to='#'
                                                className='list-group-item list-group-item-action'
                                            >
                                                آیتم چهارم
                                            </Link>

                                            <Link
                                                to='#'
                                                className='list-group-item list-group-item-action disabled'
                                                tabIndex='-1'
                                                aria-disabled='true'
                                            >
                                                آیتم غیر فعال
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-sm-12 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                فهرست گروهی معمولی و لینک دار رنگی
                            </div>

                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-sm-12 col-lg-6 mb-4'>
                                        <div className='list-group'>
                                            <Link
                                                to='#'
                                                className='list-group-item list-group-item-action list-group-item-primary'
                                            >
                                                این یک فهرست گروهی لینک دار به
                                                رنگ اصلی است
                                            </Link>

                                            <Link
                                                to='#'
                                                className='list-group-item list-group-item-action list-group-item-secondary'
                                            >
                                                این یک فهرست گروهی لینک دار به
                                                رنگ ثانوی است
                                            </Link>

                                            <Link
                                                to='#'
                                                className='list-group-item list-group-item-action list-group-item-success'
                                            >
                                                این یک فهرست گروهی لینک دار به
                                                رنگ موفقیا آمیز است
                                            </Link>

                                            <Link
                                                to='#'
                                                className='list-group-item list-group-item-action list-group-item-danger'
                                            >
                                                این یک فهرست گروهی لینک دار به
                                                رنگ اخطار است
                                            </Link>

                                            <Link
                                                to='#'
                                                className='list-group-item list-group-item-action list-group-item-warning'
                                            >
                                                این یک فهرست گروهی لینک دار به
                                                رنگ هشدار است
                                            </Link>

                                            <Link
                                                to='#'
                                                className='list-group-item list-group-item-action list-group-item-info'
                                            >
                                                این یک فهرست گروهی لینک دار به
                                                رنگ اطلاعات است
                                            </Link>

                                            <Link
                                                to='#'
                                                className='list-group-item list-group-item-action list-group-item-light'
                                            >
                                                این یک فهرست گروهی لینک دار به
                                                رنگ روشن است
                                            </Link>

                                            <Link
                                                to='#'
                                                className='list-group-item list-group-item-action list-group-item-dark'
                                            >
                                                این یک فهرست گروهی لینک دار به
                                                رنگ تیره است
                                            </Link>
                                        </div>
                                    </div>

                                    <div className='col-sm-12 col-lg-6 mb-4'>
                                        <ul className='list-group'>
                                            <li className='list-group-item list-group-item-primary'>
                                                این یک فهرست گروهی ساده به رنگ
                                                اصلی است
                                            </li>

                                            <li className='list-group-item list-group-item-secondary'>
                                                این یک فهرست گروهی ساده به رنگ
                                                ثانوی است
                                            </li>

                                            <li className='list-group-item list-group-item-success'>
                                                این یک فهرست گروهی ساده به رنگ
                                                موفقیت آمیز است
                                            </li>

                                            <li className='list-group-item list-group-item-danger'>
                                                این یک فهرست گروهی ساده به رنگ
                                                اخطار است
                                            </li>

                                            <li className='list-group-item list-group-item-warning'>
                                                این یک فهرست گروهی ساده به رنگ
                                                هشدار است
                                            </li>

                                            <li className='list-group-item list-group-item-info'>
                                                این یک فهرست گروهی ساده به رنگ
                                                اطلاعات است
                                            </li>

                                            <li className='list-group-item list-group-item-light'>
                                                این یک فهرست گروهی ساده به رنگ
                                                روشن است
                                            </li>

                                            <li className='list-group-item list-group-item-dark'>
                                                این یک فهرست گروهی ساده به رنگ
                                                تیره است
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-sm-12 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                فهرست گروهی پیام و چک باکس
                            </div>

                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-sm-12 col-lg-6 mb-4'>
                                        <ol className='list-group list-group-numbered'>
                                            <li className='list-group-item d-flex justify-content-between align-items-center'>
                                                <div className='ms-auto me-2'>
                                                    <div className='fw-bold'>
                                                        امیررضا کدخدازاده
                                                    </div>
                                                    پیام های خونده نشده
                                                </div>
                                                <span className='badge badge-danger rounded-pill'>
                                                    ۴
                                                </span>
                                            </li>

                                            <li className='list-group-item d-flex justify-content-between align-items-center'>
                                                <div className='ms-auto me-2'>
                                                    <div className='fw-bold'>
                                                        امیررضا کدخدازاده
                                                    </div>
                                                    پیام های خونده نشده
                                                </div>
                                                <span className='badge badge-danger rounded-pill'>
                                                    ۴
                                                </span>
                                            </li>

                                            <li className='list-group-item d-flex justify-content-between align-items-center'>
                                                <div className='ms-auto me-2'>
                                                    <div className='fw-bold'>
                                                        امیررضا کدخدازاده
                                                    </div>
                                                    پیام های خونده نشده
                                                </div>
                                                <span className='badge badge-danger rounded-pill'>
                                                    ۴
                                                </span>
                                            </li>

                                            <li className='list-group-item d-flex justify-content-between align-items-center'>
                                                <div className='ms-auto me-2'>
                                                    <div className='fw-bold'>
                                                        امیررضا کدخدازاده
                                                    </div>
                                                    پیام های خونده نشده
                                                </div>
                                                <span className='badge badge-danger rounded-pill'>
                                                    ۴
                                                </span>
                                            </li>

                                            <li className='list-group-item d-flex justify-content-between align-items-center'>
                                                <div className='ms-auto me-2'>
                                                    <div className='fw-bold'>
                                                        امیررضا کدخدازاده
                                                    </div>
                                                    پیام های خونده نشده
                                                </div>
                                                <span className='badge badge-danger rounded-pill'>
                                                    ۴
                                                </span>
                                            </li>
                                        </ol>
                                    </div>

                                    <div className='col-sm-12 col-lg-6 mb-4'>
                                        <div className='list-group'>
                                            <label className='list-group-item d-flex justify-content-between pointer p-3'>
                                                چک باکس اول
                                                <input
                                                    className='form-check-input me-1'
                                                    type='checkbox'
                                                />
                                            </label>

                                            <label className='list-group-item d-flex justify-content-between pointer p-3'>
                                                چک باکس دوم
                                                <input
                                                    className='form-check-input me-1'
                                                    type='checkbox'
                                                />
                                            </label>

                                            <label className='list-group-item d-flex justify-content-between pointer p-3'>
                                                چک باکس سوم
                                                <input
                                                    className='form-check-input me-1'
                                                    type='checkbox'
                                                />
                                            </label>

                                            <label className='list-group-item d-flex justify-content-between pointer p-3'>
                                                چک باکس چهارم
                                                <input
                                                    className='form-check-input me-1'
                                                    type='checkbox'
                                                />
                                            </label>

                                            <label className='list-group-item d-flex justify-content-between pointer p-3'>
                                                چک باکس پنجم
                                                <input
                                                    className='form-check-input me-1'
                                                    type='checkbox'
                                                />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-sm-12 mb-4'>
                        <div className='card'>
                            <div className='card-title bg-transparent p-3'>
                                فهرست گروهی دارای محتوا و منو عمودی
                            </div>

                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-sm-12 col-lg-6 mb-4'>
                                        <div className='list-group'>
                                            <Link
                                                to='#'
                                                className='list-group-item list-group-item-action active'
                                                aria-current='true'
                                            >
                                                <div className='d-flex w-100 justify-content-between'>
                                                    <h5 className='mb-1'>
                                                        عنوان فهرست گروهی
                                                    </h5>
                                                    <small>۳ روز پیش</small>
                                                </div>
                                                <p className='mb-1'>
                                                    لورم ایپسوم متن ساختگی با
                                                    تولید سادگی نامفهوم از صنعت
                                                    چاپ
                                                </p>
                                                <small>
                                                    یک متن کوچیک برای توضیح
                                                    بیشتر
                                                </small>
                                            </Link>

                                            <Link
                                                to='#'
                                                className='list-group-item list-group-item-action'
                                            >
                                                <div className='d-flex w-100 justify-content-between'>
                                                    <h5 className='mb-1'>
                                                        عنوان فهرست گروهی
                                                    </h5>
                                                    <small className='text-muted'>
                                                        ۳ روز پیش
                                                    </small>
                                                </div>
                                                <p className='mb-1'>
                                                    لورم ایپسوم متن ساختگی با
                                                    تولید سادگی نامفهوم از صنعت
                                                    چاپ
                                                </p>
                                                <small className='text-muted'>
                                                    یک متن کوچیک برای توضیح
                                                    بیشتر
                                                </small>
                                            </Link>

                                            <Link
                                                to='#'
                                                className='list-group-item list-group-item-action'
                                            >
                                                <div className='d-flex w-100 justify-content-between'>
                                                    <h5 className='mb-1'>
                                                        عنوان فهرست گروهی
                                                    </h5>
                                                    <small className='text-muted'>
                                                        ۳ روز پیش
                                                    </small>
                                                </div>
                                                <p className='mb-1'>
                                                    لورم ایپسوم متن ساختگی با
                                                    تولید سادگی نامفهوم از صنعت
                                                    چاپ
                                                </p>
                                                <small className='text-muted'>
                                                    یک متن کوچیک برای توضیح
                                                    بیشتر
                                                </small>
                                            </Link>
                                        </div>
                                    </div>

                                    <div className='col-sm-12 col-lg-6 mb-4'>
                                        <div className='row'>
                                            <div className='col-sm-12 col-md-6'>
                                                <div
                                                    className='list-group'
                                                    id='list-tab'
                                                    role='tablist'
                                                >
                                                    <a
                                                        className='list-group-item list-group-item-action active'
                                                        id='list-home-list'
                                                        data-bs-toggle='list'
                                                        href='#list-home'
                                                        role='tab'
                                                        aria-controls='list-home'
                                                    >
                                                        <Home
                                                            className='mr-2'
                                                            size={15}
                                                        />
                                                        خانه
                                                    </a>

                                                    <a
                                                        className='list-group-item list-group-item-action'
                                                        id='list-profile-list'
                                                        data-bs-toggle='list'
                                                        href='#list-profile'
                                                        role='tab'
                                                        aria-controls='list-profile'
                                                    >
                                                        <User
                                                            className='mr-2'
                                                            size={15}
                                                        />
                                                        پروفایل
                                                    </a>

                                                    <a
                                                        className='list-group-item list-group-item-action'
                                                        id='list-messages-list'
                                                        data-bs-toggle='list'
                                                        href='#list-messages'
                                                        role='tab'
                                                        aria-controls='list-messages'
                                                    >
                                                        <MessageSquare
                                                            className='mr-2'
                                                            size={15}
                                                        />
                                                        پیام ها
                                                    </a>

                                                    <a
                                                        className='list-group-item list-group-item-action'
                                                        id='list-settings-list'
                                                        data-bs-toggle='list'
                                                        href='#list-settings'
                                                        role='tab'
                                                        aria-controls='list-settings'
                                                    >
                                                        <Settings
                                                            className='mr-2'
                                                            size={15}
                                                        />
                                                        تنظیمات
                                                    </a>
                                                </div>
                                            </div>
                                            <div className='col-sm-12 col-md-6'>
                                                <div
                                                    className='tab-content'
                                                    id='nav-tabContent'
                                                >
                                                    <div
                                                        className='tab-pane fade show active'
                                                        id='list-home'
                                                        role='tabpanel'
                                                        aria-labelledby='list-home-list'
                                                    >
                                                        لورم ایپسوم متن ساختگی
                                                        با تولید سادگی نامفهوم
                                                        از صنعت چاپ، و با
                                                        استفاده از طراحان گرافیک
                                                        است، چاپگرها و متون بلکه
                                                        روزنامه و مجله در ستون و
                                                        سطرآنچنان که لازم است، و
                                                        برای شرایط فعلی تکنولوژی
                                                        مورد نیاز، و کاربردهای
                                                        متنوع با هدف بهبود
                                                        ابزارهای کاربردی می
                                                        باشد.
                                                    </div>

                                                    <div
                                                        className='tab-pane fade'
                                                        id='list-profile'
                                                        role='tabpanel'
                                                        aria-labelledby='list-profile-list'
                                                    >
                                                        لورم ایپسوم متن ساختگی
                                                        با تولید سادگی نامفهوم
                                                        از صنعت چاپ، و با
                                                        استفاده از طراحان گرافیک
                                                        است، چاپگرها و متون بلکه
                                                        روزنامه و مجله در ستون و
                                                        سطرآنچنان که لازم است، و
                                                        برای شرایط فعلی تکنولوژی
                                                        مورد نیاز، و کاربردهای
                                                        متنوع با هدف بهبود
                                                        ابزارهای کاربردی می
                                                        باشد.
                                                    </div>

                                                    <div
                                                        className='tab-pane fade'
                                                        id='list-messages'
                                                        role='tabpanel'
                                                        aria-labelledby='list-messages-list'
                                                    >
                                                        لورم ایپسوم متن ساختگی
                                                        با تولید سادگی نامفهوم
                                                        از صنعت چاپ، و با
                                                        استفاده از طراحان گرافیک
                                                        است، چاپگرها و متون بلکه
                                                        روزنامه و مجله در ستون و
                                                        سطرآنچنان که لازم است، و
                                                        برای شرایط فعلی تکنولوژی
                                                        مورد نیاز، و کاربردهای
                                                        متنوع با هدف بهبود
                                                        ابزارهای کاربردی می
                                                        باشد.
                                                    </div>

                                                    <div
                                                        className='tab-pane fade'
                                                        id='list-settings'
                                                        role='tabpanel'
                                                        aria-labelledby='list-settings-list'
                                                    >
                                                        لورم ایپسوم متن ساختگی
                                                        با تولید سادگی نامفهوم
                                                        از صنعت چاپ، و با
                                                        استفاده از طراحان گرافیک
                                                        است، چاپگرها و متون بلکه
                                                        روزنامه و مجله در ستون و
                                                        سطرآنچنان که لازم است، و
                                                        برای شرایط فعلی تکنولوژی
                                                        مورد نیاز، و کاربردهای
                                                        متنوع با هدف بهبود
                                                        ابزارهای کاربردی می
                                                        باشد.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
